<template>
  <generic-template :fluid="false">
    <!-- HERO -->
    <section class="flex justify-center pt-[5%] mb-24">
      <div class="w-1/2">
        <v-img
          alt="Living Evidence Logo"
          class="mr-2"
          contain
          :src="imagePath"
          transition="scale-transition"
          max-height="500"
          max-width="100%"
        />

        <div class="flex justify-center mt-4 gap-4">
          <v-btn v-if="!isLogin" @click="$router.push('/login')" small color="primary">
            {{ translate("homeView.logInBtn") }}
          </v-btn>
          <v-btn v-if="isLogin" @click="$router.push('/organizations')" small color="primary">
            {{ translate("breadcrumb.organizations") }}
          </v-btn>
          <v-btn v-if="exampleProject" @click="$router.push(exampleProject)" small color="primary">
            {{ translate("homeView.viewExample") }}
          </v-btn>
        </div>
      </div>
    </section>

    <!-- FEATURES -->
    <section>
      <div>
        <div style="height: 150px; overflow: hidden">
          <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%">
            <path
              d="M-55.01,87.34 C206.83,-40.94 327.59,147.55 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
              style="stroke: none; fill: #339999"
            ></path>
          </svg>
        </div>
      </div>

      <div class="bg-primary relative z-[1]">
        <div>
          <div class="flex justify-center mb-4">
            <h2 class="text-3xl text-center font-bold h-full w-1/2">
              <span class="text-white">{{ pillOne.title }}</span>
            </h2>
          </div>
          <div class="">
            <div class="h-full hidden md:flex md:w-1 text-white"></div>
          </div>
          <div class="flex-1">
            <div class="flex items-center h-full py-2 justify-center">
              <p class="text-lg text-justify text-white mb-0 w-1/2">{{ pillOne.description }}</p>
            </div>
          </div>
        </div>
        <div class="flex justify-center">
          <p v-html="renderFunding" class="text-lg text-justify pt-5 text-white w-1/2" />
        </div>
      </div>
      <div>
        <div style="height: 150px; overflow: hidden">
          <svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%">
            <path
              d="M-0.84,92.28 C219.24,-3.44 233.92,159.38 501.41,73.53 L500.00,0.00 L0.00,0.00 Z"
              style="stroke: none; fill: #339999"
            ></path>
          </svg>
        </div>
      </div>
    </section>
    <!-- DESCRIPTION -->
    <section class="pb-16">
      <h2 class="text-3xl px-16 text-center font-bold mb-4 text-primary">
        {{ descriptionData.title }}
      </h2>
      <div class="flex justify-center">
        <p class="text-lg text-justify mb-6 w-1/2">
          {{ descriptionData.description }}
        </p>
      </div>
      <v-img
        alt="description-image"
        class="mb-10"
        contain
        :src="descriptionData.image"
        transition="scale-transition"
        max-height="450"
        max-width="100%"
      />
      <div class="flex justify-center">
        <v-btn to="/manual" small color="primary">{{ translate("homeView.goToManual") }}</v-btn>
      </div>
    </section>
  </generic-template>
</template>

<script>
import { markdown } from "markdown";
import GenericTemplate from "@/components/ui/GenericTemplate.vue";
import { mapActions, mapState } from "vuex";
export default {
  components: { GenericTemplate },
  methods: {
    ...mapActions(["handleLogin"]),
    auth() {
      this.handleLogin({});
    },
  },
  computed: {
    ...mapState(["isLogin"]),
    exampleProject() {
      if (!process.env.VUE_APP_EXAMPLE_PROJECT) return null;
      return `/example/${process.env.VUE_APP_EXAMPLE_PROJECT}`;
    },
    renderFunding() {
      const text = this.translate("homeView.funding");

      return markdown.toHTML(text);
    },
    imagePath() {
      return require("@/assets/img/logos/logos-02.svg");
    },
    pillOne() {
      return {
        title: this.translate("homeView.pills.first.title"),
        color: "primary",
        description: this.translate("homeView.pills.first.description"),
      };
    },

    descriptionData() {
      return {
        title: this.translate("homeView.descriptionData.title"),
        description: this.translate("homeView.descriptionData.description"),
        image: require("@/assets/img/INSTRUCCIONES.png"),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.hero {
  background-image: url("../assets/img/LE-BACKGROUND.svg");
  background-size: cover;
  // background-attachment: fixed;
  background-clip: padding-box;
}
</style>
